<div class="header-container">
  <div class="main-header">Account management</div>
  <div class="tabs-container">
    @for (t of tabs; track t; let last = $last) {
      <div class="tab" [class.active]="t === activeTab()" (click)="switchTab(t)">{{ t }}</div>
      @if (!last) {
        <div class="tab separator">|</div>
      }
    }
  </div>
</div>
<div class="main-container">
  <div class="top-container">
    <app-search-bar (onSubmitSearch)="onSearch($event)" [searchControl]="searchControl"></app-search-bar>
    <app-button [text]="addButtonText()" class="primary" (clicked)="add()"></app-button>
  </div>

  <div class="table-region">
    @switch (activeTab()) {
      @case ('accounts') {
        <app-accounts-table [rows]="accountRows()" (rowClicked)="onRowClicked($event)" (sortChanged)="onSortChanged($event)"></app-accounts-table>
      }
      @case ('users') {
        <app-users-table [rows]="userRows()" (rowClicked)="onRowClicked($event)" (sortChanged)="onSortChanged($event)"></app-users-table>
      }
      @case ('brands') {
        <app-brands-table [rows]="brandRows()" (rowClicked)="onRowClicked($event)" (sortChanged)="onSortChanged($event)"></app-brands-table>
      }
    }

    @if (loading()) {
      <app-loader></app-loader>
    } @else if (error()) {
      <div class="table-overlay table-error">
        <span>Couldn't load {{ activeTab() }}. Please try again.</span>
        <app-button text="Retry" class="secondary" (clicked)="retry()"></app-button>
      </div>
    } @else if (empty()) {
      <div class="table-overlay table-empty">No {{ activeTab() }} found</div>
    }
  </div>

  <div class="bottom-container">
    <app-paginator [length]="total()" [pageSize]="pageSize()" [currentPage]="paginatorPage()" (page)="onPageChange($event)"></app-paginator>
  </div>
</div>
